import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthHelper } from '../common/roles';
import { UserService } from '../services/user.service';

export const isClientGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return AuthHelper.IsClient(userService.userInfo$$()?.roles)
    ? router.createUrlTree(['/']) // редирект на главную
    : true;
};

export const isNotClientGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return !AuthHelper.IsClient(userService.userInfo$$()?.roles)
    ? router.createUrlTree(['/']) // редирект на главную
    : true;
};
